/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Additional_Instructions_LabelInputs */



/**
* | output |
* | --- |
* | "Additional context and instructions for the LLM" |
*
* @param {Additional_Instructions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const additional_instructions_label = /** @type {((inputs?: Additional_Instructions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Additional_Instructions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Informations complémentaires et instructions pour le LLM")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusätzlicher Kontext und Anweisungen für den LLM")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contesto e istruzioni aggiuntive per il Master in Giurisprudenza (LLM)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Дополнительная информация и инструкции для программы магистра права (LLM).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contexto e instrucciones adicionales para el LLM")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关于法学硕士（LLM）的更多背景信息和说明")
	if (locale === "ja") return /** @type {LocalizedString} */ ("LLMに関する追加情報と指示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एलएलएम के लिए अतिरिक्त संदर्भ और निर्देश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Contexto e instruções adicionais para o LLM")
	return /** @type {LocalizedString} */ ("Additional context and instructions for the LLM")
});